<template>
  <div class="feedback-modal" v-if="visible" @click.self="handleCancel">
    <div class="feedback-container">
      <div class="feedback-title">{{ title }}</div>
      <div class="feedback-question">{{ question }}</div>

      <div class="emoji-container">
        <div v-for="(emoji, index) in emojis" :key="index" class="emoji-item"
          :class="{ 'selected': selectedEmoji === index }" @click="selectEmoji(index)">
          <img :src="selectedEmoji === index ? emoji.colorUrl : emoji.grayUrl" :alt="emoji.name"
            class="emoji-image" />
        </div>
      </div>

      <textarea class="feedback-textarea" :placeholder="placeholder"
        v-model="localFeedbackText"></textarea>

      <div class="feedback-buttons">
        <el-button class="cancel-btn"  @click="handleCancel">{{ cancelText }}</el-button>
        <el-button class="submit-btn" :disabled="!this.selectedEmoji || !this.localFeedbackText"  @click="handleSubmit">{{ submitText }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '用户反馈'
    },
    question: {
      type: String,
      default: '请您对于本场面试的面试体验作出评价，这有助于我们为您提供更优质的服务~'
    },
    placeholder: {
      type: String,
      default: '对于我们的服务，您可以畅所欲言，我们会努力做得更好'
    },
    cancelText: {
      type: String,
      default: '以后再说'
    },
    submitText: {
      type: String,
      default: '提交'
    },
    emojis: {
      type: Array,
      default: () => [
        {
          name: '非常满意',
          grayUrl: require('@/components/SideBar/assets/img/1-gray-cartoon.png'),
          colorUrl: require('@/components/SideBar/assets/img/1-colorful.png')
        },
        {
          name: '满意',
          grayUrl: require('@/components/SideBar/assets/img/2-gray-cartoon.png'),
          colorUrl: require('@/components/SideBar/assets/img/2-colorful.png')
        },
        {
          name: '一般',
          grayUrl: require('@/components/SideBar/assets/img/3-gray-cartoon.png'),
          colorUrl: require('@/components/SideBar/assets/img/3-colorful.png')
        },
        {
          name: '不满意',
          grayUrl: require('@/components/SideBar/assets/img/4-gray-cartoon.png'),
          colorUrl: require('@/components/SideBar/assets/img/4-colorful.png')
        },
        {
          name: '非常不满意',
          grayUrl: require('@/components/SideBar/assets/img/5-gray-cartoon.png'),
          colorUrl: require('@/components/SideBar/assets/img/5-colorful.png')
        }
      ]
    }
  },
  data() {
    return {
      selectedEmoji: null,
      localFeedbackText: ''
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        // 关闭时重置状态
        this.selectedEmoji = null
        this.localFeedbackText = ''
      }
    }
  },
  methods: {
    selectEmoji(index) {
      this.selectedEmoji = index
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleSubmit() {
      // 触发自定义提交事件，传递选中的emoji索引和反馈文本
      this.$emit('submit', {
        emojiIndex: this.selectedEmoji,
        feedbackText: this.localFeedbackText
      })
    }
  }
}
</script>

<style scoped>
/* 用户反馈模态框样式 */
.feedback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10003;
}

.feedback-container {
  width: 560px;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(177, 110, 249, 0.3);
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 10001;
}

.feedback-title {
  font-size: 36px;
  font-weight: bold;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 2vh;
  text-align: center;
}

.feedback-question {
  font-size: 1.2vw;
  color: #656587CC;
  text-align: center;
  width: 480px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  font-family: Source Han Sans CN VF;
  font-weight: 400;
  font-size: 20px;
  text-align: center;
}

.emoji-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 36px 0;
  position: relative;
  z-index: 10002;
  pointer-events: auto;
}

.emoji-item {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s;
  position: relative;
  border: 2px solid transparent;
}

.emoji-item.selected {
  border-color: rgba(177, 110, 249, 0.6);
  transform: scale(1.1);
  box-shadow: 0 0 1vw rgba(126, 180, 235, 0.4);
}

.emoji-image {
  width: 74px;
  object-fit: contain;
  transition: transform 0.2s;
}

.emoji-item:hover .emoji-image {
  transform: scale(1.1);
}

.feedback-textarea {
  width: 100%;
  min-height: 140px;
  padding: 1vh 1vw;
  border-radius: 0.8vw;
  border: 1px solid rgba(126, 180, 235, 0.5);
  background: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  margin-bottom: 2vh;
  resize: none;
  outline: none;
  position: relative;
  z-index: 10002;
  pointer-events: auto;
}

.feedback-textarea:focus {
  border-color: rgba(177, 110, 249, 0.7);
  box-shadow: 0 0 0.5vw rgba(126, 180, 235, 0.3);
}

.feedback-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 24px;
}

.cancel-btn {
  width: 230px;
  height: 40px;
  border-radius: 4px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  color: #666;
  position: relative;
  z-index: 10002;
  pointer-events: auto;
}

.submit-btn {
  width: 230px;
  height: 40px;
  border-radius: 4px;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: white;
  position: relative;
  z-index: 10002;
  pointer-events: auto;
}

.submit-btn:disabled {
  border: 1px solid #ddd;
}

.submit-btn:hover,
.cancel-btn:hover {
  transform: translateY(-0.2vh);
  box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}
</style>

